const checksTextWithinQuotes = /'([^']+)'/ig;
const checksQuotes = /['"]+/g;
const checkmodalReferenceIdString = /modal_reference_id='([^']+)'/ig;

export { checksTextWithinQuotes, checksQuotes, checkmodalReferenceIdString };